export default {
  SET_EVENTS(state, payload) {
    state.events = payload
  },
  SET_LAST_FETCH(state, payload) {
    state.lastFetch = payload
  }
}
